import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import {ENTITY_SHAPE} from 'constants/UserConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import FormInput from 'ui-library/bs/FormInput';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

function EntityList({entities, onChange, type, validate}) {
  const rows = entities.map((entity, i) => (
    <EntityRow
      key={entity.handle}
      index={i}
      entity={entity}
      onChange={onChange}
      type={type}
      validate={validate}
    />
  ));

  return (
    <div>
      {rows.length > 0 ? (
        rows
      ) : (
        <span className="u-tiny-spacing-top u-small-spacing-left">
          <HorizontalThrobber />
        </span>
      )}
    </div>
  );
}

function EntityRow({entity, index, onChange, type, validate}) {
  const error = validate(entity.initials);
  return (
    <Row className="membersScreen-list-row">
      <Col sm={4} className="membersScreen-list-handle">
        {entity.handle}
        <div className="membersScreen-member-subtext">{type}</div>
      </Col>
      <Col sm={4} className="membersScreen-list-name">
        {entity.name}
      </Col>
      <Col sm={4}>
        <FormInput
          className={classNames('membersScreen-input', {error})}
          value={entity.initials}
          placeholder="Enter initials"
          onChange={(event) => onChange(event.target.value, index)}
        />
        <div className="membersScreen-input-errorMessage">{error}</div>
      </Col>
    </Row>
  );
}

EntityList.propTypes = {
  entities: PropTypes.arrayOf(ENTITY_SHAPE).isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
};

EntityRow.propTypes = {
  index: PropTypes.number,
  entity: ENTITY_SHAPE.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  validate: PropTypes.func.isRequired,
};

export default EntityList;
